/**
 * A verdict landing on a record.
 *
 * Approvals, signatures and evidence marks arrive rather than fade in — a small
 * overshoot and settle, which reads as something being *applied* to a document.
 * `opacity` is untouched here too, so the verdict is legible before, during and
 * after; only its scale moves.
 */
import { m } from 'motion/react'
import type { ReactNode } from 'react'

import { useReducedMotionSafe } from './motion'

export function Stamp({
  children,
  delay = 0,
  className,
}: {
  children: ReactNode
  delay?: number
  className?: string
}) {
  const reduced = useReducedMotionSafe()

  if (reduced) return <span className={className}>{children}</span>

  return (
    <m.span
      className={className}
      initial={{ scale: 1.35, rotate: -4 }}
      whileInView={{ scale: 1, rotate: 0 }}
      viewport={{ once: true, margin: '-40px' }}
      transition={{ type: 'spring', stiffness: 420, damping: 18, delay }}
      style={{ display: 'inline-block', transformOrigin: 'center' }}
    >
      {children}
    </m.span>
  )
}
